import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      border: '1px solid rgba(255, 0, 0, .1)',
      borderRadius: '8px',
      padding: 16,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
      cursor: 'pointer',
    },
    buttonText: {
      fontSize: 16,
    },
    chevron: {
      height: 14,
    },
  },
  {
    name: 'Auth0SelectButton',
  },
);
